import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

// -- actions
import { RestaurantMenuAction, RouteAction } from 'actions';

// -- entities
import Menu from 'PMT/entities/menu/Menu';

class ProductDetailMenuRow extends Component {

  static propTypes = {
    menu: PropTypes.instanceOf(Menu).isRequired
  };

  shouldComponentUpdate(nextProps) {
    return !nextProps.menu.equals(this.props.menu);
  }

  onDisplayDetailClick = () => {
    RouteAction.presentMenuDetail(this.menu);
  };

  get menu() {
    return this.props.menu;
  }

  // -- renderers

  render() {
    return (
      <li
        onClick={this.onDisplayDetailClick}
      >
        <h4 className="link-hover">
          {this.menu.name}
        </h4>
      </li>
    );
  }

}

export default ProductDetailMenuRow;
